export interface FirebaseEnvConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
  functionsRegion: string;
  appCheckSiteKey: string;
  useEmulators: boolean;
}

export function getFirebaseEnvConfig(): FirebaseEnvConfig {
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY ?? '';
  const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '';
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '';
  const storageBucket = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '';
  const messagingSenderId = import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '';
  const appId = import.meta.env.VITE_FIREBASE_APP_ID ?? '';
  const measurementId = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? '';
  const functionsRegion = import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION ?? 'southamerica-east1';
  const appCheckSiteKey = import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY ?? '';
  const useEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';

  return {
    apiKey,
    authDomain,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
    functionsRegion,
    appCheckSiteKey,
    useEmulators,
  };
}
